import { Icon } from "@constellation-academy/epic-ui";
import { motion } from "framer-motion";
import { ChevronDownIcon } from "primereact/icons/chevrondown";
import { ChevronUpIcon } from "primereact/icons/chevronup";
import { useState } from "react";
import { P2Span } from "@themes/font-tags";
import {
	cardClass,
	childrenWrapperClass,
	contentClass,
	contentWrapperClass,
	expandButtonClass,
	iconWrapperClass,
	valueClass,
	titleClass,
	wrapperClass,
} from "./content-finished-expandable-item.styles";
import { ContentFinishedExpandableItemProps } from "./content-finished-expandable-item.types";

export const ContentFinishedExpandableItemComponent = ({
	title,
	value,
	children,
	icon,
	iconVariant,
	iconRenderer,
}: ContentFinishedExpandableItemProps) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const toggleExpanded = () => {
		setIsExpanded((prev) => !prev);
	};

	return (
		<div className={wrapperClass}>
			<motion.div className={cardClass}>
				<div
					className={iconWrapperClass({
						iconVariant,
					})}
				>
					{iconRenderer ?? <Icon icon={icon} />}
				</div>
				<div className={contentClass}>
					<P2Span className={titleClass}>{title}</P2Span>
					<div className={contentWrapperClass}>
						<span className={valueClass}>{value}</span>
					</div>
				</div>
				<button type="button" className={expandButtonClass} onClick={toggleExpanded}>
					{isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
				</button>
				{isExpanded && <div className={childrenWrapperClass}>{children}</div>}
			</motion.div>
		</div>
	);
};
